/** @format */
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cardServices } from '../../../../Services/card.services';
import AsyncSelect from 'react-select/async';
import { lettersOnly } from '../../../../Config/Regex';
import { tenantPaymentMethodServices } from '../../../../Services/tenantPaymentMethod.service';
import CardsTable from './CardsTable';

const AddPaymentMethod = ({
	show,
	setShow,
	tenantId,
	onHide,
	setResultModal,
}) => {
	const { t: translator } = useTranslation();

	const [selectedCards, setSelectedCards] = useState([]);
	const [fiscalTagValue, setFiscalTagValue] = useState('');

	const { handleSubmit, errors, register } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	const onSubmit = data => {
		tenantPaymentMethodServices
			.createPaymentMethod({
				tenantId: tenantId,
				name: data.name,
				tag: data.tag,
				fiscalTag: data.fiscalTag,
				useFiscalization: data.useFiscalization,
				creditCardIds: selectedCards,
			})
			.then(res => {
				onHide();
				setResultModal({
					show: true,
					title: translator('CardTypes-AssignPaymentMethod-SuccesModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};

	return (
		<Modal
			show={show}
			onHide={() => {
				setShow(false);
			}}
			size={'lg'}
			centered>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Modal.Header closeButton>
					<Modal.Title>{translator('TenantPaymentMethod-AddNew')}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<fieldset className='scheduler-border'>
						<div className='row'>
							<div className='col-lg-6'>
								<legend className='scheduler-border mb-3 '>
									{translator('TenantPaymentMethod-Data')}
								</legend>

								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-Name')}
									</label>
									<input
										className='form-control'
										type='text'
										name='name'
										ref={register({
											required: true,
											pattern: lettersOnly,
											maxLength: 20,
										})}
									/>

									{errors.name && errors.name.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
									{errors.name && errors.name.type === 'pattern' && (
										<p className='text-danger'>
											{translator('ValidationMsg-LettersOnly')}
										</p>
									)}
									{errors.name && errors.name.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength20')}
										</p>
									)}
								</div>
								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-Tag')}
									</label>
									<input
										className='form-control'
										type='text'
										name='tag'
										ref={register({
											required: true,
											maxLength: 1,
										})}
									/>
									{errors.tag && errors.tag.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
									{errors.tag && errors.tag.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength1')}
										</p>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='ddlStore'>
										{translator('PaymentMethod-FiscalTag')}
									</label>
									<select
										className='form-control'
										name='fiscalTag'
										aria-label='Default select example'
										ref={register({ required: true })}
										onChange={e => {
											setFiscalTagValue(e.target.value);
											setSelectedCards([]);
										}}>
										<option>G</option>
										<option>K</option>
										<option>T</option>
										<option>O</option>
									</select>

									{errors.fiscalTag && errors.fiscalTag.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
								</div>

								<div className='form-group'>
									<label className='labelCont'>
										<input
											ref={register}
											type='checkbox'
											name='useFiscalization'
										/>
										<span className='checkmark'></span>
									</label>
									<span className='Data'>
										{translator('AddTenantPaymentMethod-UseFiscalization')}
									</span>{' '}
									{/* <Tooltip text={translator('Users-PriceEditing-Msg')} /> */}
								</div>
							</div>
							<div className='col-lg-6'>
								{fiscalTagValue === 'K' && (
									<CardsTable
										selectedItems={selectedCards}
										setSelectedItems={setSelectedCards}
									/>
								)}
							</div>
						</div>
					</fieldset>
				</Modal.Body>

				<Modal.Footer>
					<Button
						variant='secondary'
						onClick={() => {
							setShow(false);
						}}>
						{translator('Btn-Cancel')}
					</Button>
					<button className='btn btn-primary' type='submit'>
						{translator('Btn-Save')}
					</button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default AddPaymentMethod;
